import React from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import * as THREE from 'three';

// Add a new component to handle wireframe opacity
export function WireframeOpacity({ wireframes, modelRef }: { 
  wireframes: THREE.LineSegments[],
  modelRef: React.RefObject<THREE.Object3D>
}) {
  const { camera } = useThree();
  
  useFrame(() => {
    if (modelRef.current) {
      // Get a center point of the model
      const box = new THREE.Box3().setFromObject(modelRef.current);
      const center = new THREE.Vector3();
      box.getCenter(center);
      
      // Calculate distance from camera to model center
      const distance = camera.position.distanceTo(center);
      
      // Adjust wireframe visibility based on distance
      wireframes.forEach(wireframe => {
        if (wireframe.material) {
          const material = wireframe.material as THREE.LineBasicMaterial;
          
          // Fade out wireframe as camera gets farther away, but keep it more visible
          if (distance < 10) {
            // Close to the model - full visibility
            material.opacity = 0.95;
          } else if (distance > 40) {
            // Far from model - but still visible
            material.opacity = 0.5;
          } else {
            // Linear interpolation for distances in between
            material.opacity = 0.95 - ((distance - 10) / 30) * 0.45; // Less reduction in opacity
          }
        }
      });
    }
  });
  
  return null;
} 